// Note: Bootstrap tooltip initialization has been replaced with Reactstrap's UncontrolledTooltip
import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import { Card, CardBody, CardHeader, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Alert, Input, Label, UncontrolledTooltip } from "reactstrap";
import ReviewSlider from "../../Components/Common/ReviewSlider";
import SimpleBar from "simplebar-react";
import "simplebar-react/dist/simplebar.min.css";
import "flag-icons/css/flag-icons.min.css";
import { dashboardEvents, dashboardWebSocket } from "../../services/websocket/DashboardWebSocket.tsx";
import UserDetailsModal from "../../Components/Common/UserDetailsModal";
import useUserDetails from "../../hooks/useUserDetails";
import LoadingSpinner from '../../Components/Common/LoadingSpinner';

//import images
import product8 from "../../assets/images/products/img-8.png";
import product2 from "../../assets/images/products/img-2.png";
import product10 from "../../assets/images/products/img-10.png";
import avatar2 from "../../assets/images/users/avatar-2.jpg";
import avatar3 from "../../assets/images/users/avatar-3.jpg";
import gitbox from "../../assets/images/giftbox.png";

//SimpleBar
import { topCategories } from "../../common/data";

// Add country code mapping
const countryToCode = {
  'india': 'in',
  'united states': 'us',
  'united kingdom': 'gb',
  'canada': 'ca',
  'australia': 'au',
  'germany': 'de',
  'france': 'fr',
  'italy': 'it',
  'spain': 'es',
  'japan': 'jp',
  'china': 'cn',
  'russia': 'ru',
  'brazil': 'br',
  'mexico': 'mx',
  'south korea': 'kr',
  'singapore': 'sg',
  'malaysia': 'my',
  'indonesia': 'id',
  'philippines': 'ph',
  'thailand': 'th',
  'vietnam': 'vn',
  'pakistan': 'pk',
  'bangladesh': 'bd',
  'sri lanka': 'lk',
  'nepal': 'np',
  'uae': 'ae',
  'saudi arabia': 'sa',
  'qatar': 'qa',
  'kuwait': 'kw',
  'bahrain': 'bh',
  'oman': 'om',
  'turkey': 'tr',
  'egypt': 'eg',
  'south africa': 'za',
  'nigeria': 'ng',
  'kenya': 'ke',
  'ghana': 'gh',
  'morocco': 'ma',
  'algeria': 'dz',
  'tunisia': 'tn',
  'ethiopia': 'et',
  'tanzania': 'tz',
  'uganda': 'ug',
  'rwanda': 'rw',
  'zimbabwe': 'zw',
  'zambia': 'zm',
  'mozambique': 'mz',
  'namibia': 'na',
  'botswana': 'bw',
  'mauritius': 'mu',
  'seychelles': 'sc',
  'madagascar': 'mg',
  'comoros': 'km',
  'djibouti': 'dj',
  'eritrea': 'er',
  'somalia': 'so',
  'sudan': 'sd',
  'south sudan': 'ss',
  'central african republic': 'cf',
  'chad': 'td',
  'niger': 'ne',
  'mali': 'ml',
  'burkina faso': 'bf',
  'senegal': 'sn',
  'gambia': 'gm',
  'guinea': 'gn',
  'guinea-bissau': 'gw',
  'sierra leone': 'sl',
  'liberia': 'lr',
  'ivory coast': 'ci',
  'cote d\'ivoire': 'ci',
  'togo': 'tg',
  'benin': 'bj',
  'equatorial guinea': 'gq',
  'gabon': 'ga',
  'congo': 'cg',
  'democratic republic of the congo': 'cd',
  'angola': 'ao',
  'cameroon': 'cm',
  'burundi': 'bi',
  'lesotho': 'ls',
  'swaziland': 'sz',
  'eswatini': 'sz',
  'malawi': 'mw',
  'new zealand': 'nz',
  'fiji': 'fj',
  'papua new guinea': 'pg',
  'solomon islands': 'sb',
  'vanuatu': 'vu',
  'samoa': 'ws',
  'tonga': 'to',
  'kiribati': 'ki',
  'tuvalu': 'tv',
  'nauru': 'nr',
  'marshall islands': 'mh',
  'palau': 'pw',
  'micronesia': 'fm',
  'argentina': 'ar',
  'bolivia': 'bo',
  'chile': 'cl',
  'colombia': 'co',
  'ecuador': 'ec',
  'guyana': 'gy',
  'paraguay': 'py',
  'peru': 'pe',
  'suriname': 'sr',
  'uruguay': 'uy',
  'venezuela': 've',
  'belize': 'bz',
  'costa rica': 'cr',
  'el salvador': 'sv',
  'guatemala': 'gt',
  'honduras': 'hn',
  'nicaragua': 'ni',
  'panama': 'pa',
  'antigua and barbuda': 'ag',
  'bahamas': 'bs',
  'barbados': 'bb',
  'cuba': 'cu',
  'dominica': 'dm',
  'dominican republic': 'do',
  'grenada': 'gd',
  'haiti': 'ht',
  'jamaica': 'jm',
  'saint kitts and nevis': 'kn',
  'saint lucia': 'lc',
  'saint vincent and the grenadines': 'vc',
  'trinidad and tobago': 'tt',
  'austria': 'at',
  'belgium': 'be',
  'bulgaria': 'bg',
  'croatia': 'hr',
  'cyprus': 'cy',
  'czech republic': 'cz',
  'denmark': 'dk',
  'estonia': 'ee',
  'finland': 'fi',
  'greece': 'gr',
  'hungary': 'hu',
  'ireland': 'ie',
  'latvia': 'lv',
  'lithuania': 'lt',
  'luxembourg': 'lu',
  'malta': 'mt',
  'netherlands': 'nl',
  'poland': 'pl',
  'portugal': 'pt',
  'romania': 'ro',
  'slovakia': 'sk',
  'slovenia': 'si',
  'sweden': 'se',
  'iceland': 'is',
  'norway': 'no',
  'switzerland': 'ch',
  'liechtenstein': 'li',
  'monaco': 'mc',
  'andorra': 'ad',
  'san marino': 'sm',
  'vatican city': 'va'
};

// Helper function to convert hex color to RGB
const hexToRgb = (hex) => {
  // Remove the hash if it exists
  hex = hex.replace('#', '');
  
  // Parse the hex values
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  
  // Return the RGB values as a string
  return `${r}, ${g}, ${b}`;
};

// Add this helper function after the countryToCode mapping
const getCountryCode = (country) => {
  if (!country) return null;
  
  // Convert to lowercase for matching
  const countryLower = country.toLowerCase();
  
  // Direct lookup in the mapping
  if (countryToCode[countryLower]) {
    console.log(`Found country code for ${country}: ${countryToCode[countryLower]}`);
    return countryToCode[countryLower];
  }
  
  // Handle special cases
  if (countryLower === 'na' || countryLower === 'n/a' || countryLower === 'unknown') {
    return null;
  }
  
  // Special handling for common countries that might be in uppercase
  if (countryLower === 'canada') return 'ca';
  if (countryLower === 'india') return 'in';
  if (countryLower === 'united states' || countryLower === 'usa') return 'us';
  if (countryLower === 'united kingdom' || countryLower === 'uk') return 'gb';
  if (countryLower === 'australia') return 'au';
  
  // Log unrecognized country for debugging
  console.log('Unrecognized country:', country);
  return null;
};

// Helper function to determine if a color is light or dark
const isLightColor = (color) => {
  // Default to dark if color is not provided
  if (!color) return false;
  
  // Handle hex colors
  let r, g, b;
  
  if (color.startsWith('#')) {
    // Remove the hash
    const hex = color.substring(1);
    
    // Handle shorthand hex (#fff)
    if (hex.length === 3) {
      r = parseInt(hex.charAt(0) + hex.charAt(0), 16);
      g = parseInt(hex.charAt(1) + hex.charAt(1), 16);
      b = parseInt(hex.charAt(2) + hex.charAt(2), 16);
    } else {
      r = parseInt(hex.substring(0, 2), 16);
      g = parseInt(hex.substring(2, 4), 16);
      b = parseInt(hex.substring(4, 6), 16);
    }
  } 
  // Handle rgb/rgba colors
  else if (color.startsWith('rgb')) {
    const rgbValues = color.match(/\d+/g);
    if (rgbValues && rgbValues.length >= 3) {
      r = parseInt(rgbValues[0]);
      g = parseInt(rgbValues[1]);
      b = parseInt(rgbValues[2]);
    } else {
      return false; // Default to dark if parsing fails
    }
  } 
  // Default to dark for other color formats
  else {
    return false;
  }
  
  // Calculate perceived brightness using the formula:
  // (0.299*R + 0.587*G + 0.114*B)
  const brightness = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  
  // Return true if the color is light (brightness > 0.5)
  return brightness > 0.5;
};

// Add this function at the top level of the file, before the component definition
const addCacheBuster = (url) => {
  if (!url) {
    console.warn('Null or empty URL passed to addCacheBuster');
    return url;
  }
  
  if (typeof url !== 'string') {
    console.warn('Non-string URL passed to addCacheBuster:', typeof url, url);
    return url;
  }
  
  try {
    // Generate a unique cache-busting value
    const cacheBuster = `cb=${new Date().getTime()}-${Math.random().toString(36).substr(2, 9)}`;
    const separator = url.includes('?') ? '&' : '?';
    const finalUrl = `${url}${separator}${cacheBuster}`;
    
    // Only log the first few uses to avoid console spam
    const logCount = window._cacheBusterLogCount = (window._cacheBusterLogCount || 0) + 1;
    if (logCount <= 5) {
      console.log(`Cache busting URL [${logCount}]: ${url.substring(0, 100)}... → ${finalUrl.substring(0, 110)}...`);
    }
    
    return finalUrl;
  } catch (error) {
    console.error('Error in addCacheBuster:', error);
    return url; // Return original URL if there's an error
  }
};

// Update the processProfileUrl function with improved logic
const processProfileUrl = (url) => {
  if (!url) return null;
  
  // Add console logging for debugging
  if (typeof url !== 'string') {
    console.warn('Non-string URL received:', url);
    return null;
  }
  
  // Handle special case for CloudFront URLs - these may be the source of CORS issues
  if (url.includes('cloudfront.net')) {
    console.log('CloudFront URL detected:', url);
    return addCacheBuster(url);
  }
  
  // If it's already an absolute URL with http/https, return it with cache buster
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return addCacheBuster(url);
  }

  // Handle profile-media paths more specifically
  if (url.includes('profile-media')) {
    const mediaBaseUrl = process.env.REACT_APP_MEDIA_BASE_URL || 'https://d3su94xl0oo42g.cloudfront.net';
    // Check if the URL already has the base URL
    if (url.includes(mediaBaseUrl)) {
      return addCacheBuster(url);
    }
    
    // If it's just the path, prepend the base URL
    const baseWithoutTrailingSlash = mediaBaseUrl.endsWith('/') ? mediaBaseUrl.slice(0, -1) : mediaBaseUrl;
    const urlWithoutLeadingSlash = url.startsWith('/') ? url.slice(1) : url;
    return addCacheBuster(`${baseWithoutTrailingSlash}/${urlWithoutLeadingSlash}`);
  }

  // If it's a relative URL, prepend the media base URL
  const mediaBaseUrl = process.env.REACT_APP_MEDIA_BASE_URL || process.env.REACT_APP_MEDIA_URL || 'https://d3su94xl0oo42g.cloudfront.net/';
  
  // Make sure we don't have double slashes
  const baseWithoutTrailingSlash = mediaBaseUrl.endsWith('/') ? mediaBaseUrl.slice(0, -1) : mediaBaseUrl;
  const urlWithoutLeadingSlash = url.startsWith('/') ? url.slice(1) : url;
  
  const fullUrl = `${baseWithoutTrailingSlash}/${urlWithoutLeadingSlash}`;
  return addCacheBuster(fullUrl);
};

// Add a helper function to detect sample data
const isSampleData = (data, type) => {
  if (!data || data.length === 0) return true;
  
  if (type === 'activities') {
    // Check if it's the default sample activity
    if (data.length === 1 && 
        data[0].type === 'video_call' && 
        data[0].user === 'John Doe' && 
        data[0].target_user === 'Jane Smith') {
      return true;
    }
  }
  
  if (type === 'matches') {
    // Check if it's the default sample match
    if (data.length === 1 && 
        data[0].first_user?.name === 'John Doe' && 
        data[0].second_user?.name === 'Jane Smith') {
      return true;
    }
  }
  
  if (type === 'subscriptions') {
    // Check if it's the default sample subscription
    if (data.length === 1 && 
        data[0].user === 'John Doe' && 
        data[0].country === 'United States') {
      return true;
    }
  }
  
  if (type === 'topLocations') {
    // Check if it's the default sample location
    if (data.length === 1 && 
        data[0].city === 'New York' && 
        data[0].country === 'United States') {
      return true;
    }
  }
  
  return false;
};

const RecentActivity = ({ dashboardData: propsDashboardData = {} }) => {
  const [dashboardData, setDashboardData] = useState({
    activities: propsDashboardData.activities || [],
    matches: propsDashboardData.matches || [],
    subscriptions: propsDashboardData.subscriptions || []
  });
  const [error, setError] = useState(null);
  const [connectionStatus, setConnectionStatus] = useState(() => {
    return window.dashboardWS && window.dashboardWS.readyState === WebSocket.OPEN ? 'connected' : 'disconnected';
  });
  const [autoRefresh, setAutoRefresh] = useState(true);

  // Function to toggle auto refresh
  const toggleAutoRefresh = () => {
    setAutoRefresh(!autoRefresh);
  };

  // Function to request new data from WebSocket
  const onRequestData = () => {
    console.log('Requesting new data from WebSocket...');
    
    // Check if WebSocket is available and connected
    if (window.dashboardWS && window.dashboardWS.readyState === WebSocket.OPEN) {
      try {
        const requestDataMessage = {
          type: 'request_data',
          payload: {
            metrics: [
              'active_users',
              'recent_activities',
              'recent_matches',
              'recent_subscriptions',
              'top_locations'
            ]
          }
        };
        
        console.log('Sending data request message:', requestDataMessage);
        window.dashboardWS.send(JSON.stringify(requestDataMessage));
        setConnectionStatus('waiting for updates');
      } catch (error) {
        console.error('Error sending data request:', error);
        setError('Failed to request data: ' + error.message);
      }
    } else if (window.dashboardWebSocket && typeof window.dashboardWebSocket.connect === 'function') {
      // If WebSocket is not connected, try to reconnect
      console.log('WebSocket not connected, attempting to reconnect...');
      setConnectionStatus('connecting');
      window.dashboardWebSocket.connect();
    } else {
      console.error('WebSocket not available');
      setError('WebSocket connection not available');
    }
  };

  // Update local state when props change
  useEffect(() => {
    // Only update from props if we don't already have data from WebSocket
    // This prevents the default data from overriding the API data
    setDashboardData(prev => {
      // Only use props data for each category if we don't already have data
      const activities = prev.activities && prev.activities.length > 0 
        ? prev.activities 
        : (propsDashboardData.activities || []);
      
      const matches = prev.matches && prev.matches.length > 0 
        ? prev.matches 
        : (propsDashboardData.matches || []);
      
      const subscriptions = prev.subscriptions && prev.subscriptions.length > 0 
        ? prev.subscriptions 
        : (propsDashboardData.subscriptions || []);
      
      // Keep other properties from previous state
      return {
        ...prev,
        activities,
        matches,
        subscriptions
      };
    });
  }, [propsDashboardData]);

  // Debug log for received data
  useEffect(() => {
    console.log('RecentActivity - Received dashboard data:', dashboardData);
  }, [dashboardData]);

  const {
    userDetailsModal,
    setUserDetailsModal,
    selectedUser,
    loadingUser,
    fetchUserDetails
  } = useUserDetails();

  // Function to render connection status
  const renderConnectionStatus = () => {
  return (
      <div 
        id="websocket-status-icon-recent"
        className="websocket-status-icon ms-auto" 
        onClick={onRequestData}
        style={{
          cursor: 'pointer',
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: 
            connectionStatus === 'connecting' ? '#f8f9fa' :
            connectionStatus === 'connected' || connectionStatus === 'authenticated' || connectionStatus === 'subscribed' ? '#d1e7dd' :
            connectionStatus === 'waiting for updates' ? '#cff4fc' :
            connectionStatus === 'error' || connectionStatus === 'closed' ? '#f8d7da' :
            '#fff3cd',
          border: '1px solid',
          borderColor:
            connectionStatus === 'connecting' ? '#dee2e6' :
            connectionStatus === 'connected' || connectionStatus === 'authenticated' || connectionStatus === 'subscribed' ? '#badbcc' :
            connectionStatus === 'waiting for updates' ? '#b6effb' :
            connectionStatus === 'error' || connectionStatus === 'closed' ? '#f5c2c7' :
            '#ffecb5',
          transition: 'all 0.3s ease'
        }}
      >
        {connectionStatus === 'connecting' ? (
          <i className="ri-loader-4-line spin" style={{ color: '#6c757d', fontSize: '14px' }}></i>
        ) : connectionStatus === 'connected' || connectionStatus === 'authenticated' || connectionStatus === 'subscribed' ? (
          <i className="ri-wifi-line" style={{ color: '#198754', fontSize: '14px' }}></i>
        ) : connectionStatus === 'waiting for updates' ? (
          <i className="ri-refresh-line spin" style={{ color: '#0dcaf0', fontSize: '14px' }}></i>
        ) : connectionStatus === 'error' ? (
          <i className="ri-error-warning-line" style={{ color: '#dc3545', fontSize: '14px' }}></i>
        ) : connectionStatus === 'closed' ? (
          <i className="ri-plug-line" style={{ color: '#dc3545', fontSize: '14px' }}></i>
        ) : (
          <i className="ri-wifi-off-line" style={{ color: '#ffc107', fontSize: '14px' }}></i>
        )}
      </div>
    );
  };

  const toggleUserModal = () => {
    setUserDetailsModal(!userDetailsModal);
  };

  const handleUserClick = (user) => {
    console.log('User clicked:', user);
    
    // Add debugging to see the structure of the user object
    console.log('User object type:', typeof user);
    console.log('User object keys:', user ? Object.keys(user) : 'null');
    
    // Check if user is an object with an id property
    if (user && typeof user === 'object') {
      // Try different ID formats based on the API response
      const userId = user.id || user.user_id || 
                    (user.subscriber && user.subscriber.id) || 
                    user.userId || 
                    (user._id || user.id || null);
      
      if (userId) {
        console.log('Found user ID:', userId);
        fetchUserDetails(userId);
        return;
      }
      
      // Check if user itself is an ID string
      if (typeof user === 'string' && user.length > 5) {
        console.log('User appears to be an ID string:', user);
        fetchUserDetails(user);
        return;
      }
      
      // Log all properties to help debug
      console.log('All user properties:', user);
      
      // If we couldn't find an ID, show a warning
      console.warn('Could not determine user ID from:', user);
      alert('User details not available. Please check the console for more information.');
    } else if (typeof user === 'string') {
      // If user is a string, assume it's a user ID
      console.log('User is a string, using as ID:', user);
      fetchUserDetails(user);
    } else {
      // If we can't determine the user ID, show a warning
      console.warn('Could not determine user ID from:', user);
      alert('User details not available');
    }
  };

  // Add this helper function after the handleUserClick function
  const getProfilePictureUrl = (profileData) => {
    if (!profileData) return null;
    
    console.log('Getting profile picture from:', profileData);

    // If profileData is an array (like in the API response)
    if (Array.isArray(profileData)) {
      // Find the first PHOTO type item
      const photoItem = profileData.find(item => item.type === 'PHOTO');
      if (photoItem && photoItem.url) {
        console.log('Found photo item in array:', photoItem);
        return photoItem.url;
      }
      // If no PHOTO type, just use the first item's URL
      if (profileData.length > 0 && profileData[0].url) {
        console.log('Using first item from array:', profileData[0]);
        return profileData[0].url;
      }
      return null;
    }
    
    // Existing logic for non-array data
    if (typeof profileData === 'string') {
      if (profileData.includes('profile-media')) {
        console.log('Found profile-media path in string:', profileData);
      }
      return profileData;
    }
    
    if (typeof profileData === 'object') {
      // Check for url property directly on the object
      if (profileData.url) {
        return profileData.url;
      }
      
      // Check for various image-related properties
      const urlProps = ['picture', 'photo', 'image', 'avatar'];
      for (const prop of urlProps) {
        if (profileData[prop]) {
          return profileData[prop];
        }
      }
      
      // Check for a profile property that might contain the image
      if (profileData.profile && typeof profileData.profile === 'object') {
        if (profileData.profile.url) {
          return profileData.profile.url;
        }
        for (const prop of urlProps) {
          if (profileData.profile[prop]) {
            return profileData.profile[prop];
          }
        }
      }
    }
    
    return null;
  };

  useEffect(() => {
    // Listen for WebSocket updates
    const handleActivitiesUpdate = (activities) => {
      
      // Handle different possible formats of the activities data
      let activitiesArray = activities;
      
      // If activities is an object with a data property, use that
      if (activities && !Array.isArray(activities) && activities.data) {
        activitiesArray = activities.data;
      }
      
      // If activities is an object with an activities property, use that
      if (activities && !Array.isArray(activities) && activities.activities) {
        activitiesArray = activities.activities;
      }
      
      // If activities is a string (JSON), try to parse it
      if (typeof activities === 'string') {
        try {
          activitiesArray = JSON.parse(activities);
        } catch (error) {
          console.error('Failed to parse activities JSON string:', error);
        }
      }
      
      // Ensure activitiesArray is an array
      if (!Array.isArray(activitiesArray)) {
        console.warn('Activities is not an array after processing:', activitiesArray);
        return;
      }
      
      if (activitiesArray.length > 0) {
        // Validate each activity to ensure it has the required properties
        const validatedActivities = activitiesArray.map(activity => {
          if (!activity) return null;
          
          // Create a copy of the activity
          const validatedActivity = { ...activity };
          
          // Handle user property which can be either a string or an object
          if (typeof validatedActivity.user === 'object' && validatedActivity.user !== null) {
            // User is an object, extract the name and avatar
            validatedActivity.userName = validatedActivity.user.name || 'Unknown User';
            validatedActivity.userId = validatedActivity.user.id || '';
            
            // Process avatar if available
            if (validatedActivity.user.avatar && Array.isArray(validatedActivity.user.avatar) && validatedActivity.user.avatar.length > 0) {
              // Get the first photo from avatar array
              const profilePhoto = validatedActivity.user.avatar.find(item => item.type === 'PHOTO');
              if (profilePhoto) {
                validatedActivity.userAvatarUrl = profilePhoto.url || '';
              }
            }
            // Keep the original user object
          } else if (typeof validatedActivity.user === 'string') {
            // User is already a string, use it as userName
            validatedActivity.userName = validatedActivity.user;
            validatedActivity.userId = '';
          } else {
            // User is neither an object nor a string
            validatedActivity.user = { name: 'Unknown User', id: '' };
            validatedActivity.userName = 'Unknown User';
            validatedActivity.userId = '';
          }
          
          // Handle target_user property which can be either a string or an object
          if (typeof validatedActivity.target_user === 'object' && validatedActivity.target_user !== null) {
            // Target user is an object, extract the name and avatar
            validatedActivity.targetUserName = validatedActivity.target_user.name || 'Unknown User';
            validatedActivity.targetUserId = validatedActivity.target_user.id || '';
            
            // Process avatar if available
            if (validatedActivity.target_user.avatar && Array.isArray(validatedActivity.target_user.avatar) && validatedActivity.target_user.avatar.length > 0) {
              // Get the first photo from avatar array
              const profilePhoto = validatedActivity.target_user.avatar.find(item => item.type === 'PHOTO');
              if (profilePhoto) {
                validatedActivity.targetUserAvatarUrl = profilePhoto.url || '';
              }
            }
            // Keep the original target_user object
          } else if (typeof validatedActivity.target_user === 'string') {
            // Target user is already a string, use it as targetUserName
            validatedActivity.targetUserName = validatedActivity.target_user;
            validatedActivity.targetUserId = '';
          }
          
          // Ensure type is a string
          if (typeof validatedActivity.type !== 'string') {
            validatedActivity.type = String(validatedActivity.type || 'unknown');
          }
          
          // Ensure time or timestamp is available
          if (!validatedActivity.time && validatedActivity.timestamp) {
            // Convert timestamp to ISO string if it's a number
            if (typeof validatedActivity.timestamp === 'number') {
              validatedActivity.time = new Date(validatedActivity.timestamp * 1000).toISOString();
            } else {
              validatedActivity.time = String(validatedActivity.timestamp);
            }
          } else if (!validatedActivity.time) {
            validatedActivity.time = new Date().toISOString();
          }
          
          // Handle token_transaction specific fields
          if (validatedActivity.type === 'token_transaction') {
            // Ensure tokens is a number
            validatedActivity.tokens = typeof validatedActivity.tokens === 'number' 
              ? validatedActivity.tokens 
              : parseInt(validatedActivity.tokens) || 0;
              
            // Ensure transaction_type is a string
            if (!validatedActivity.transaction_type) {
              validatedActivity.transaction_type = 'Token Transaction';
            }
            
            // Ensure transaction_category is a string (CREDIT or DEBIT)
            if (!validatedActivity.transaction_category) {
              validatedActivity.transaction_category = validatedActivity.tokens >= 0 ? 'CREDIT' : 'DEBIT';
            }
            
            // Set default icon and color if not provided
            if (!validatedActivity.icon) {
              validatedActivity.icon = '💫';
            }
            
            if (!validatedActivity.color) {
              validatedActivity.color = '#FFD700'; // Gold color for token transactions
            }
          }
          
          // Handle virtual_gift specific fields
          if (validatedActivity.type === 'virtual_gift') {
            // Ensure tokens/amount is a number
            validatedActivity.tokens = validatedActivity.tokens || validatedActivity.amount || 0;
            
            // Set default icon and color if not provided
            if (!validatedActivity.icon) {
              validatedActivity.icon = '🎁';
            }
            
            if (!validatedActivity.color) {
              validatedActivity.color = '#E91E63'; // Pink color for gifts
            }
          }
          
          // Handle video_call specific fields
          if (validatedActivity.type === 'video_call') {
            // Ensure status is uppercase
            if (validatedActivity.status) {
              validatedActivity.status = validatedActivity.status.toUpperCase();
            } else {
              validatedActivity.status = 'UNKNOWN';
            }
            
            // Set default icon and color if not provided
            if (!validatedActivity.icon) {
              validatedActivity.icon = '🎥';
            }
            
            if (!validatedActivity.color) {
              validatedActivity.color = '#2196F3'; // Blue color for video calls
            }
          }
          
          return validatedActivity;
        }).filter(Boolean); // Remove any null/undefined items
        
        
        if (validatedActivities.length > 0) {
          setDashboardData(prev => {
            const updatedData = {
              ...prev,
              activities: [...validatedActivities, ...(prev.activities || [])].slice(0, 10) // Keep last 10 activities
            };
            return updatedData;
          });
        } else {
          console.warn('No valid activities after validation');
        }
      } else {
        console.warn('Received empty activities array');
      }
    };
    
    // Add handler for current active users
    const handleCurrentActiveUsersUpdate = (data) => {
      
      // Handle different possible formats of the data
      let activeUsersData = data;
      
      // If data is an object with a data property, use that
      if (data && !Array.isArray(data) && data.data) {
        activeUsersData = data.data;
      }
      
      // If data is an object with an active_users property, use that
      if (data && !Array.isArray(data) && data.active_users) {
        activeUsersData = data.active_users;
      }
      
      if (activeUsersData) {
        // Validate and ensure the data has the required properties
        const validatedData = {
          total: typeof activeUsersData.total === 'number' ? activeUsersData.total : parseInt(activeUsersData.total) || 0,
          online: typeof activeUsersData.online === 'number' ? activeUsersData.online : parseInt(activeUsersData.online) || 0,
          mobile: typeof activeUsersData.mobile === 'number' ? activeUsersData.mobile : parseInt(activeUsersData.mobile) || 0,
          // Split mobile users between android and ios if not provided directly
          android: typeof activeUsersData.android === 'number' ? activeUsersData.android : 
                   (typeof activeUsersData.mobile === 'number' ? Math.floor(activeUsersData.mobile * 0.7) : 0), // Assume 70% Android if not specified
          ios: typeof activeUsersData.ios === 'number' ? activeUsersData.ios : 
               (typeof activeUsersData.mobile === 'number' ? Math.ceil(activeUsersData.mobile * 0.3) : 0), // Assume 30% iOS if not specified
          trend: activeUsersData.trend || 'stable',
          peak: activeUsersData.peak || '0',
          lastUpdated: activeUsersData.lastUpdated || new Date().toISOString()
        };
        
        setDashboardData(prev => {
          const updatedData = {
            ...prev,
            currentActiveUsers: validatedData
          };
          return updatedData;
        });
      } else {
        console.warn('Received invalid current active users data:', data);
      }
    };
    
    // Add handler for active users (alternative event name)
    const handleActiveUsersUpdate = (data) => {
      
      // Handle different possible formats of the data
      let activeUsersData = data;
      
      // If data is an object with a data property, use that
      if (data && !Array.isArray(data) && data.data) {
        activeUsersData = data.data;
      }
      
      // If data is an object with an active_users property, use that
      if (data && !Array.isArray(data) && data.active_users) {
        activeUsersData = data.active_users;
      }
      
      if (activeUsersData) {
        // Validate and ensure the data has the required properties
        const validatedData = {
          total: typeof activeUsersData.total === 'number' ? activeUsersData.total : parseInt(activeUsersData.total) || 0,
          online: typeof activeUsersData.online === 'number' ? activeUsersData.online : parseInt(activeUsersData.online) || 0,
          mobile: typeof activeUsersData.mobile === 'number' ? activeUsersData.mobile : parseInt(activeUsersData.mobile) || 0,
          // Split mobile users between android and ios if not provided directly
          android: typeof activeUsersData.android === 'number' ? activeUsersData.android : 
                   (typeof activeUsersData.mobile === 'number' ? Math.floor(activeUsersData.mobile * 0.7) : 0), // Assume 70% Android if not specified
          ios: typeof activeUsersData.ios === 'number' ? activeUsersData.ios : 
               (typeof activeUsersData.mobile === 'number' ? Math.ceil(activeUsersData.mobile * 0.3) : 0), // Assume 30% iOS if not specified
          trend: activeUsersData.trend || 'stable',
          peak: activeUsersData.peak || '0',
          lastUpdated: activeUsersData.lastUpdated || new Date().toISOString()
        };
        
        setDashboardData(prev => {
          const updatedData = {
            ...prev,
            currentActiveUsers: validatedData
          };
          return updatedData;
        });
      } else {
        console.warn('Received invalid active users data:', data);
      }
    };
    
    const handleMatchesUpdate = (matches) => {
      console.log('RecentActivity component received matches update:', matches);
      
      // Handle different possible formats of the matches data
      let matchesArray = matches;
      
      // If matches is a string (JSON), try to parse it
      if (typeof matches === 'string') {
        try {
          matchesArray = JSON.parse(matches);
          console.log('Parsed matches from JSON string:', matchesArray);
        } catch (error) {
          console.error('Failed to parse matches JSON string:', error);
        }
      }
      
      // If matches is an object with a data property, use that
      if (matches && !Array.isArray(matches) && matches.data) {
        console.log('Matches has a data property, using that:', matches.data);
        matchesArray = matches.data;
      }
      
      // If matches is an object with a matches property, use that
      if (matches && !Array.isArray(matches) && matches.matches) {
        console.log('Matches has a matches property, using that:', matches.matches);
        matchesArray = matches.matches;
      }
      
      // If matchesArray is not an array but a single object, wrap it in an array
      if (matchesArray && !Array.isArray(matchesArray) && typeof matchesArray === 'object') {
        console.log('Matches is a single object, wrapping in array:', matchesArray);
        matchesArray = [matchesArray];
      }
      
      // Ensure matchesArray is an array
      if (!Array.isArray(matchesArray)) {
        console.warn('Matches is not an array after processing:', matchesArray);
        return;
      }
      
      if (matchesArray.length > 0) {
        // Validate each match to ensure it has the required properties
        const validatedMatches = matchesArray.map(match => {
          if (!match) return null;
          
          const validatedMatch = { ...match };
          
          // Handle new format with user1 and user2
          if (validatedMatch.user1 && validatedMatch.user2) {
            console.log('Processing new match format with user1 and user2 fields');
            
            // Preserve the original user1 and user2 references
            validatedMatch.originalUser1 = validatedMatch.user1;
            validatedMatch.originalUser2 = validatedMatch.user2;
            
            // Map user1 to first_user
            validatedMatch.first_user = {
              id: validatedMatch.user1.id || '',
              name: validatedMatch.user1.name || 'Unknown User',
            };
            
            // Add avatar URL if available
            if (validatedMatch.user1.avatar && Array.isArray(validatedMatch.user1.avatar) && validatedMatch.user1.avatar.length > 0) {
              const profilePhoto = validatedMatch.user1.avatar.find(item => item.type === 'PHOTO');
              if (profilePhoto) {
                validatedMatch.first_user.avatarUrl = profilePhoto.url || '';
              }
            }
            
            // Map user2 to second_user
            validatedMatch.second_user = {
              id: validatedMatch.user2.id || '',
              name: validatedMatch.user2.name || 'Unknown User',
            };
            
            // Add avatar URL if available
            if (validatedMatch.user2.avatar && Array.isArray(validatedMatch.user2.avatar) && validatedMatch.user2.avatar.length > 0) {
              const profilePhoto = validatedMatch.user2.avatar.find(item => item.type === 'PHOTO');
              if (profilePhoto) {
                validatedMatch.second_user.avatarUrl = profilePhoto.url || '';
              }
            }
            
            // Set location if available
            if (validatedMatch.user1.location) {
              validatedMatch.location = validatedMatch.user1.location.city || 'N/A';
              if (validatedMatch.user1.location.country) {
                validatedMatch.location += `, ${validatedMatch.user1.location.country}`;
              }
            }
            
            // Set time from timestamp
            if (validatedMatch.timestamp) {
              validatedMatch.time = new Date(validatedMatch.timestamp).toISOString();
            } else {
              validatedMatch.time = new Date().toISOString();
            }
            
            // Set match type
            validatedMatch.matchType = validatedMatch.matchType || 'match';
            
            // Set match color and icon based on match type
            if (validatedMatch.matchType.toLowerCase().includes('guest')) {
              validatedMatch.color = '#FF9800'; // Orange for guest matches
              validatedMatch.icon = 'ri-user-star-line';
            } else if (validatedMatch.matchType.toLowerCase().includes('premium')) {
              validatedMatch.color = '#4b49ac'; // Purple for premium matches
              validatedMatch.icon = 'ri-vip-crown-line';
            } else {
              validatedMatch.color = '#4CAF50'; // Green for regular matches
              validatedMatch.icon = 'ri-heart-line';
            }
          }
          
          // Ensure first_user is an object
          if (!validatedMatch.first_user || typeof validatedMatch.first_user !== 'object') {
            validatedMatch.first_user = {
              id: '',
              name: validatedMatch.first_user || 'Unknown User'
            };
          }
          
          // Ensure second_user is an object
          if (!validatedMatch.second_user || typeof validatedMatch.second_user !== 'object') {
            validatedMatch.second_user = {
              id: '',
              name: validatedMatch.second_user || 'Unknown User'
            };
          }
          
          // Ensure time is a string
          if (!validatedMatch.time) {
            validatedMatch.time = new Date().toISOString();
          }
          
          // Ensure location is a string
          validatedMatch.location = validatedMatch.location || 'N/A';
          
          // Debug logging for match data
          console.log('Validated match:', {
            first_user: validatedMatch.first_user,
            second_user: validatedMatch.second_user,
            time: validatedMatch.time,
            location: validatedMatch.location,
            matchType: validatedMatch.matchType
          });
          
          return validatedMatch;
        }).filter(Boolean); // Remove any null/undefined items
        
        console.log('Validated matches before updating state:', validatedMatches);
        
        if (validatedMatches.length > 0) {
          setDashboardData(prev => {
            const updatedData = {
              ...prev,
              matches: [...validatedMatches, ...(prev.matches || [])].slice(0, 10) // Keep last 10 matches
            };
            console.log('Updated dashboard data with new matches:', updatedData);
            return updatedData;
          });
        } else {
          console.warn('No valid matches after validation');
        }
      } else {
        console.warn('Received empty matches array');
      }
    };
    
    const handleSubscriptionsUpdate = (subscriptions) => {
      
      // Handle different possible formats of the subscriptions data
      let subscriptionsArray = subscriptions;
      
      // If subscriptions is a string (JSON), try to parse it
      if (typeof subscriptions === 'string') {
        try {
          subscriptionsArray = JSON.parse(subscriptions);
        } catch (error) {
          console.error('Failed to parse subscriptions JSON string:', error);
        }
      }
      
      // If subscriptions is an object with a data property, use that
      if (subscriptions && !Array.isArray(subscriptions) && subscriptions.data) {
        subscriptionsArray = subscriptions.data;
      }
      
      // If subscriptions is an object with a subscriptions property, use that
      if (subscriptions && !Array.isArray(subscriptions) && subscriptions.subscriptions) {
        subscriptionsArray = subscriptions.subscriptions;
      }
      
      // If subscriptionsArray is not an array but a single object, wrap it in an array
      if (subscriptionsArray && !Array.isArray(subscriptionsArray) && typeof subscriptionsArray === 'object') {
        subscriptionsArray = [subscriptionsArray];
      }
      
      // Ensure subscriptionsArray is an array
      if (!Array.isArray(subscriptionsArray)) {
        console.warn('Subscriptions is not an array after processing:', subscriptionsArray);
        return;
      }
      
      if (subscriptionsArray.length > 0) {
        // Validate each subscription to ensure it has the required properties
        const validatedSubscriptions = subscriptionsArray.map(subscription => {
          if (!subscription) return null;
          
          const validatedSubscription = { ...subscription };
          
          // Handle new subscription format with user_id, user, profile_pic, country, plan, duration, etc.
          if (validatedSubscription.user_id && validatedSubscription.user) {
            
            // Set userId from user_id
            validatedSubscription.userId = validatedSubscription.user_id;
            
            // Set userName from user if it's a string
            if (typeof validatedSubscription.user === 'string') {
              validatedSubscription.userName = validatedSubscription.user;
            }
            
            // Process profile_pic if available
            if (validatedSubscription.profile_pic) {
              const profileUrl = getProfilePictureUrl(validatedSubscription.profile_pic);
              if (profileUrl) {
                validatedSubscription.userAvatarUrl = profileUrl;
              }
            }
            
            // Set plan details
            validatedSubscription.planName = validatedSubscription.plan || 'Unknown Plan';
            
            // Set country
            validatedSubscription.countryName = validatedSubscription.country || 'Unknown';
            
            // Set flag emoji if available
            if (validatedSubscription.flag && validatedSubscription.flag !== '🌐') {
              validatedSubscription.flagEmoji = validatedSubscription.flag;
            } else {
              // Try to derive flag from country
              const countryCode = getCountryCode(validatedSubscription.country);
              if (countryCode) {
                validatedSubscription.flagEmoji = `flag-icon-${countryCode}`;
              } else {
                validatedSubscription.flagEmoji = '🌐';
              }
            }
            
            // Set icon emoji if available
            validatedSubscription.iconEmoji = validatedSubscription.icon || '';
            
            // Set color if available
            validatedSubscription.planColor = validatedSubscription.color || '#4b49ac';
            
            // Set duration
            validatedSubscription.planDuration = validatedSubscription.duration || 1;
          } 
          // Handle legacy format with subscriber and subscription objects
          else if (validatedSubscription.subscriber && validatedSubscription.subscription) {
            
            // Extract subscriber details
            const subscriber = validatedSubscription.subscriber;
            validatedSubscription.user = subscriber;
            validatedSubscription.userName = subscriber.name || 'Unknown User';
            validatedSubscription.userId = subscriber.id || '';
            
            // Process avatar if available
            if (subscriber.avatar && Array.isArray(subscriber.avatar) && subscriber.avatar.length > 0) {
              // Get the first photo from avatar array
              const profilePhoto = subscriber.avatar.find(item => item.type === 'PHOTO');
              if (profilePhoto) {
                validatedSubscription.userAvatarUrl = profilePhoto.url || '';
              }
            }
            
            // Extract subscription details
            const subscriptionDetails = validatedSubscription.subscription;
            validatedSubscription.planName = subscriptionDetails.plan_id || 'Premium';
            validatedSubscription.amount = subscriptionDetails.amount || 0;
            validatedSubscription.planDuration = subscriptionDetails.duration || 1;
            
            // Set plan color and icon based on plan name
            if (validatedSubscription.planName.toLowerCase().includes('premium')) {
              validatedSubscription.planColor = '#4b49ac'; // Purple for Premium
              validatedSubscription.iconEmoji = '✨';
            } else if (validatedSubscription.planName.toLowerCase().includes('black')) {
              validatedSubscription.planColor = '#000000'; // Black for Black
              validatedSubscription.iconEmoji = '⚡';
            } else {
              validatedSubscription.planColor = validatedSubscription.color || '#4b49ac'; // Default color
              validatedSubscription.iconEmoji = validatedSubscription.icon || '🔔';
            }
            
            // Extract location details
            if (subscriber.location) {
              validatedSubscription.countryName = subscriber.location.country || 'Unknown';
              validatedSubscription.flagEmoji = subscriber.location.flag || '🌐';
            }
            
            // Set time from timestamp
            if (validatedSubscription.timestamp) {
              validatedSubscription.time = new Date(validatedSubscription.timestamp).toISOString();
            } else {
              validatedSubscription.time = new Date().toISOString();
            }
          } 
          // Handle other formats
          else {
            // Handle user which can be an object or string
            if (typeof validatedSubscription.user === 'object' && validatedSubscription.user !== null) {
              // User is an object, extract the name and avatar
              validatedSubscription.userName = validatedSubscription.user.name || 'Unknown User';
              validatedSubscription.userId = validatedSubscription.user.id || '';
              
              // Process avatar if available
              if (validatedSubscription.user.avatar && Array.isArray(validatedSubscription.user.avatar) && validatedSubscription.user.avatar.length > 0) {
                // Get the first photo from avatar array
                const profilePhoto = validatedSubscription.user.avatar.find(item => item.type === 'PHOTO');
                if (profilePhoto) {
                  validatedSubscription.userAvatarUrl = profilePhoto.url || '';
                }
              }
              // Keep the original user object
            } else if (typeof validatedSubscription.user === 'string') {
              // User is already a string, use it as userName
              validatedSubscription.userName = validatedSubscription.user;
              validatedSubscription.userId = '';
            } else {
              // User is neither an object nor a string
              validatedSubscription.user = 'Unknown User';
              validatedSubscription.userName = 'Unknown User';
              validatedSubscription.userId = '';
            }
            
            // Ensure plan is a string
            validatedSubscription.planName = validatedSubscription.plan || 'Unknown Plan';
            
            // Ensure country is a string
            validatedSubscription.countryName = validatedSubscription.country || 'Unknown';
            
            // Ensure time is a string
            if (!validatedSubscription.time) {
              validatedSubscription.time = new Date().toISOString();
            }
            
            // Set plan color and icon based on plan name
            if (validatedSubscription.planName.toLowerCase().includes('premium')) {
              validatedSubscription.planColor = '#4b49ac'; // Purple for Premium
              validatedSubscription.iconEmoji = '✨';
            } else if (validatedSubscription.planName.toLowerCase().includes('black')) {
              validatedSubscription.planColor = '#000000'; // Black for Black
              validatedSubscription.iconEmoji = '⚡';
            } else {
              validatedSubscription.planColor = validatedSubscription.color || '#4b49ac'; // Default color
              validatedSubscription.iconEmoji = validatedSubscription.icon || '🔔';
            }
            
            // Ensure flag is a string
            if (!validatedSubscription.flagEmoji) {
              // Try to derive flag from country
              const countryCode = getCountryCode(validatedSubscription.countryName);
              if (countryCode) {
                validatedSubscription.flagEmoji = `flag-icon-${countryCode}`;
              } else {
                validatedSubscription.flagEmoji = '🌐';
              }
            }
            
            // Set duration
            validatedSubscription.planDuration = validatedSubscription.duration || 1;
          }
          
          
          return validatedSubscription;
        }).filter(Boolean); // Remove any null/undefined items
        
        
        if (validatedSubscriptions.length > 0) {
          setDashboardData(prev => {
            const updatedData = {
              ...prev,
              subscriptions: [...validatedSubscriptions, ...(prev.subscriptions || [])].slice(0, 10) // Keep last 10 subscriptions
            };
            return updatedData;
          });
        } else {
          console.warn('No valid subscriptions after validation');
        }
      } else {
        console.warn('Received empty subscriptions array');
      }
    };
    
    const handleLocationsUpdate = (locations) => {
      console.log('RecentActivity component received locations update:', locations);
      
      // Handle different possible formats of the locations data
      let locationsArray = locations;
      
      // If locations is a string (JSON), try to parse it
      if (typeof locations === 'string') {
        try {
          locationsArray = JSON.parse(locations);
          console.log('Parsed locations from JSON string:', locationsArray);
        } catch (error) {
          console.error('Failed to parse locations JSON string:', error);
        }
      }
      
      // If locations is an object with a data property, use that
      if (locations && !Array.isArray(locations) && locations.data) {
        console.log('Locations has a data property, using that:', locations.data);
        locationsArray = locations.data;
      }
      
      // If locations is an object with a locations property, use that
      if (locations && !Array.isArray(locations) && locations.locations) {
        console.log('Locations has a locations property, using that:', locations.locations);
        locationsArray = locations.locations;
      }
      
      // Ensure locationsArray is an array
      if (!Array.isArray(locationsArray)) {
        console.warn('Locations is not an array after processing:', locationsArray);
        return;
      }
      
      if (locationsArray.length > 0) {
        // Validate each location to ensure it has the required properties
        const validatedLocations = locationsArray.map(location => {
          if (!location) return null;
          
          const validatedLocation = { ...location };
          
          // Ensure city is a string
          validatedLocation.city = validatedLocation.city || 'Unknown City';
          
          // Ensure country is a string
          validatedLocation.country = validatedLocation.country || 'Unknown Country';
          
          // Ensure count is a number
          validatedLocation.count = parseInt(validatedLocation.count || 0, 10);
          
          // Ensure trend is a string (up, down, or stable)
          if (validatedLocation.trend) {
            // Normalize trend value to 'up', 'down', or 'stable'
            const trendLower = validatedLocation.trend.toLowerCase();
            if (trendLower.includes('up') || trendLower.includes('increase') || trendLower.includes('positive')) {
              validatedLocation.trend = 'up';
            } else if (trendLower.includes('down') || trendLower.includes('decrease') || trendLower.includes('negative')) {
              validatedLocation.trend = 'down';
            } else {
              validatedLocation.trend = 'stable';
            }
          } else {
            validatedLocation.trend = 'stable';
          }
          
          // Ensure flag is a string
          if (!validatedLocation.flag) {
            // Try to derive flag from country
            const countryCode = getCountryCode(validatedLocation.country);
            if (countryCode) {
              validatedLocation.flag = countryCode;
            } else {
              validatedLocation.flag = '🌐';
            }
          }
          
          return validatedLocation;
        }).filter(Boolean); // Remove any null/undefined items
        
        // Sort locations by count in descending order
        validatedLocations.sort((a, b) => b.count - a.count);
        
        console.log('Validated locations before updating state:', validatedLocations);
        
        if (validatedLocations.length > 0) {
          setDashboardData(prev => {
            const updatedData = {
              ...prev,
              topLocations: validatedLocations
            };
            console.log('Updated dashboard data with new locations:', updatedData);
            return updatedData;
          });
        } else {
          console.warn('No valid locations after validation');
        }
      } else {
        console.warn('Received empty locations array');
      }
    };
    
    // Add event listeners for connection status
    if (window.dashboardEvents) {
      window.dashboardEvents.on('dashboard:activities', handleActivitiesUpdate);
      window.dashboardEvents.on('dashboard:matches', handleMatchesUpdate);
      window.dashboardEvents.on('dashboard:subscriptions', handleSubscriptionsUpdate);
      window.dashboardEvents.on('dashboard:currentActiveUsers', handleCurrentActiveUsersUpdate);
      window.dashboardEvents.on('dashboard:locations', handleLocationsUpdate);
      
      
      // Add connection status listeners with improved logging
      window.dashboardEvents.on('websocket:connected', () => {
        console.log('RecentActivity: WebSocket connected event received');
        setConnectionStatus('connected');
      });
      
      window.dashboardEvents.on('websocket:connecting', () => {
        console.log('RecentActivity: WebSocket connecting event received');
        setConnectionStatus('connecting');
      });
      
      window.dashboardEvents.on('websocket:disconnected', () => {
        console.log('RecentActivity: WebSocket disconnected event received');
        setConnectionStatus('disconnected');
      });
      
      window.dashboardEvents.on('websocket:authenticated', () => {
        console.log('RecentActivity: WebSocket authenticated event received');
        setConnectionStatus('connected');
      });
      
      window.dashboardEvents.on('websocket:error', (err) => {
        console.error('WebSocket error in RecentActivity:', err);
        setError(err);
        setConnectionStatus('disconnected');
      });
      
      // Cleanup function
      return () => {
        if (window.dashboardEvents) {
          window.dashboardEvents.off('dashboard:activities', handleActivitiesUpdate);
          window.dashboardEvents.off('dashboard:matches', handleMatchesUpdate);
          window.dashboardEvents.off('dashboard:subscriptions', handleSubscriptionsUpdate);
          window.dashboardEvents.off('dashboard:currentActiveUsers', handleCurrentActiveUsersUpdate);
          window.dashboardEvents.off('dashboard:locations', handleLocationsUpdate);
          
          
          // Remove connection status listeners
          window.dashboardEvents.off('websocket:connected');
          window.dashboardEvents.off('websocket:connecting');
          window.dashboardEvents.off('websocket:disconnected');
          window.dashboardEvents.off('websocket:authenticated');
          window.dashboardEvents.off('websocket:error');
        }
      };
    }
  }, []);

  // Add a useEffect to log when dashboardData changes
  useEffect(() => {
    console.log('dashboardData updated:', dashboardData);
  }, [dashboardData]);

  // Set up interval to refresh data
  useEffect(() => {
    let interval = null;
    
    if (autoRefresh) {
      // Set up interval to refresh data every 30 seconds
      interval = setInterval(() => {
        console.log('Auto-refreshing dashboard data...');
        
        // Request new data if WebSocket is connected
        if (window.dashboardWS && window.dashboardWS.readyState === WebSocket.OPEN) {
          try {
            const requestDataMessage = {
              type: 'request_data',
              payload: {
                metrics: [
                  'active_users',
                  'recent_activities',
                  'recent_matches',
                  'recent_subscriptions',
                  'top_locations'
                ]
              }
            };
            
            console.log('Sending auto-refresh request...');
            window.dashboardWS.send(JSON.stringify(requestDataMessage));
          } catch (error) {
            console.error('Error sending auto-refresh request:', error);
          }
        }
      }, 30000); // 30 seconds
    }
    
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [autoRefresh]);

//   // Initialize tooltips
  useEffect(() => {
//     // Initialize tooltips
    const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
    tooltipTriggerList.map(function (tooltipTriggerEl) {
//       return new window.bootstrap.Tooltip(tooltipTriggerEl);
    });
    
    return () => {
      // Dispose tooltips
      tooltipTriggerList.forEach(tooltipTriggerEl => {
//         const tooltip = window.bootstrap.Tooltip.getInstance(tooltipTriggerEl);
        if (tooltip) {
          tooltip.dispose();
        }
      });
    };
  }, []);

  useEffect(() => {
    // Add CSS for spin animation
    const style = document.createElement('style');
    style.innerHTML = `
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
      .spin {
        animation: spin 1.5s linear infinite;
      }
      .websocket-status-icon {
        transition: all 0.3s ease;
      }
      .websocket-status-icon:hover {
        transform: scale(1.1);
        box-shadow: 0 0 5px rgba(0,0,0,0.2);
      }
    `;
    document.head.appendChild(style);
    
    return () => {
      // Remove the style element
      document.head.removeChild(style);
    };
  }, []);

  // Add a useEffect hook to the component to load the first subscription's image when the component mounts
  const firstSubscriptionImageRef = useRef(null);
  
  // Add a special effect for loading the first subscription's image
  useEffect(() => {
    // Only run if we have subscriptions
    if (dashboardData.subscriptions && dashboardData.subscriptions.length > 0) {
      const firstSubscription = dashboardData.subscriptions[0];
      
      // Log the full structure of the first subscription for debugging
      console.log('First subscription data:', JSON.stringify(firstSubscription, null, 2));
      
      // Check if we have profile_pic as an array
      if (firstSubscription.profile_pic && Array.isArray(firstSubscription.profile_pic)) {
        // Find the first PHOTO type item
        const photoItem = firstSubscription.profile_pic.find(item => item.type === 'PHOTO');
        const profileUrl = photoItem?.url || 
                          (firstSubscription.profile_pic.length > 0 ? firstSubscription.profile_pic[0].url : null);
        
        if (profileUrl) {
          // Process the URL to get the full path
          const mediaBaseUrl = process.env.REACT_APP_MEDIA_BASE_URL || 'https://d3su94xl0oo42g.cloudfront.net';
          const baseWithoutTrailingSlash = mediaBaseUrl.endsWith('/') ? mediaBaseUrl.slice(0, -1) : mediaBaseUrl;
          const urlWithoutLeadingSlash = profileUrl.startsWith('/') ? profileUrl.slice(1) : profileUrl;
          const fullUrl = `${baseWithoutTrailingSlash}/${urlWithoutLeadingSlash}`;
          
          console.log('First subscription profile image URL in effect:', fullUrl);
          
          // If we have a ref to the image container, try to set the background image
          if (firstSubscriptionImageRef.current) {
            // Preload the image
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.referrerPolicy = 'no-referrer';
            
            img.onload = () => {
              console.log('First subscription image loaded successfully in effect');
              if (firstSubscriptionImageRef.current) {
                firstSubscriptionImageRef.current.style.backgroundImage = `url(${fullUrl})`;
                firstSubscriptionImageRef.current.style.backgroundSize = 'cover';
                firstSubscriptionImageRef.current.style.backgroundPosition = 'center';
                
                // Hide the fallback initial
                const fallback = firstSubscriptionImageRef.current.querySelector('.fallback-initial');
                if (fallback) {
                  fallback.style.opacity = '0';
                }
              }
            };
            
            img.onerror = (error) => {
              console.error('Error loading first subscription image in effect:', fullUrl, error);
              
              // Try an alternative loading method if it's a CloudFront URL
              if (fullUrl.includes('cloudfront.net')) {
                console.log('Attempting alternative CloudFront image loading method');
                
                // Try to use a fetch request to check accessibility
                fetch(fullUrl, { 
                  method: 'HEAD',
                  mode: 'no-cors',
                  cache: 'no-cache'
                })
                .then(() => {
                  console.log('CloudFront image fetch succeeded, trying to set as background');
                  
                  // Set directly as the background image
                  if (firstSubscriptionImageRef.current) {
                    const newImage = new Image();
                    newImage.crossOrigin = 'anonymous';
                    newImage.onload = () => {
                      if (firstSubscriptionImageRef.current) {
                        firstSubscriptionImageRef.current.style.backgroundImage = `url(${fullUrl})`;
                        firstSubscriptionImageRef.current.style.backgroundSize = 'cover';
                        firstSubscriptionImageRef.current.style.backgroundPosition = 'center';
                        
                        // Hide the fallback initial
                        const fallback = firstSubscriptionImageRef.current.querySelector('.fallback-initial');
                        if (fallback) {
                          fallback.style.opacity = '0';
                        }
                      }
                    };
                    
                    // Add random query param to avoid caching issues
                    const randomParam = `nocache=${Math.random()}`;
                    const urlWithParam = fullUrl.includes('?') 
                      ? `${fullUrl}&${randomParam}` 
                      : `${fullUrl}?${randomParam}`;
                    
                    newImage.src = urlWithParam;
                  }
                })
                .catch(err => {
                  console.error('CloudFront image fetch failed:', err);
                });
              }
            };
            
            // Add cache buster and set source
            const cacheBuster = `?cb=${new Date().getTime()}-${Math.random().toString(36).substr(2, 5)}`;
            img.src = `${fullUrl}${cacheBuster}`;
          }
        }
      }
    }
  }, [dashboardData.subscriptions]);

  return (
    <div className="right-sidebar">
      {/* Remove the renderConnectionStatus call here */}
      
      {/* Debug log for activities */}
      
      {/* Current Active Users */}
      <Card className="card-animate">
        <CardHeader className="align-items-center d-flex">
          <h5 className="card-title mb-0 flex-grow-1">Current Active Users</h5>
          <div className="flex-shrink-0">
            {dashboardData.currentActiveUsers?.trend && (
              <span className="badge bg-success-subtle text-success">
                <i className="ri-arrow-right-up-line align-middle"></i> {dashboardData.currentActiveUsers.trend}
              </span>
            )}
          </div>
        </CardHeader>
            <CardBody className="p-0">
              <div className="p-3">
            <div className="d-flex align-items-center">
              <div className="avatar-sm flex-shrink-0">
                <span className="avatar-title bg-primary-subtle text-primary rounded-circle fs-3">
                  <i className="ri-pulse-line"></i>
                </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                <div className="d-flex align-items-center">
                  <h2 className="mb-0">{dashboardData.currentActiveUsers?.total?.toLocaleString() || '0'}</h2>
                  <div className="ms-2">
                    <small className="text-muted fs-12 d-block">active users</small>
                    <span className={`badge bg-${dashboardData.currentActiveUsers?.trend === 'up' ? 'success' : dashboardData.currentActiveUsers?.trend === 'down' ? 'danger' : 'warning'}-subtle text-${dashboardData.currentActiveUsers?.trend === 'up' ? 'success' : dashboardData.currentActiveUsers?.trend === 'down' ? 'danger' : 'warning'}`}>
                      <i className={`ri-arrow-${dashboardData.currentActiveUsers?.trend === 'up' ? 'up' : dashboardData.currentActiveUsers?.trend === 'down' ? 'down' : 'right'}-line align-middle`}></i> {dashboardData.currentActiveUsers?.trend?.toUpperCase()}
                    </span>
                    </div>
                  </div>
                <p className="text-muted mb-0">Peak today: {dashboardData.currentActiveUsers?.peak || '0'}</p>
                      </div>
                    </div>
            
            <div className="mt-3 pt-2 border-top">
              <div className="row g-3">
                {/* Android Users */}
                <div className="col-6">
                  <div className="d-flex align-items-center">
                    <div className="avatar-xs flex-shrink-0">
                      <span className="avatar-title bg-success-subtle text-success rounded">
                        <i className="ri-android-line"></i>
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <h6 className="mb-0">Android Users</h6>
                      <p className="text-muted mb-0">{dashboardData.currentActiveUsers?.android?.toLocaleString() || '0'} active now</p>
                      </div>
                    </div>
                  </div>

                {/* iOS Users */}
                <div className="col-6">
                  <div className="d-flex align-items-center">
                    <div className="avatar-xs flex-shrink-0">
                      <span className="avatar-title bg-info-subtle text-info rounded">
                        <i className="ri-apple-line"></i>
                      </span>
                    </div>
                    <div className="flex-grow-1 ms-3">
                      <h6 className="mb-0">iOS Users</h6>
                      <p className="text-muted mb-0">{dashboardData.currentActiveUsers?.ios?.toLocaleString() || '0'} active now</p>
                    </div>
                  </div>
                        </div>

                {/* Last Updated */}
                <div className="col-12">
                  <div className="text-muted text-center border-top pt-2 mt-2 smaller">
                    <i className="ri-time-line align-middle me-1"></i>
                    Last updated: {new Date(dashboardData.currentActiveUsers?.lastUpdated).toLocaleString()}
                      </div>
                    </div>
                    </div>
                  </div>
                        </div>
        </CardBody>
      </Card>

      {/* Recent Activities */}
      <Card className="card-height-100" style={{ height: "510px", overflow: "hidden" }}>
        <CardHeader className="d-flex align-items-center">
          <h4 className="card-title mb-0 flex-grow-1">Recent Activity</h4>
          <div className="d-flex gap-1">
            {/* Remove the renderConnectionStatus call and UncontrolledTooltip here */}
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="customSwitchsizesm1"
                checked={autoRefresh}
                onChange={toggleAutoRefresh}
              />
              <label className="form-check-label" htmlFor="customSwitchsizesm1">Auto Refresh</label>
                      </div>
                    </div>
        </CardHeader>
        <CardBody className="p-0">
          <SimpleBar style={{ height: "500px" }}>
            <div className="p-3">
              {!dashboardData.activities?.length || isSampleData(dashboardData.activities, 'activities') ? (
                <LoadingSpinner message="Loading activities..." />
              ) : (
                dashboardData.activities.map((activity, index) => {
                  // Get the media URL from environment variables
                  const mediaUrl = process.env.REACT_APP_MEDIA_URL || '';
                  
                  // Determine user avatar URL
                  const userAvatarUrl = activity.userAvatarUrl 
                    ? `${mediaUrl}${activity.userAvatarUrl}` 
                    : null;
                  
                  // Determine target user avatar URL
                  const targetUserAvatarUrl = activity.targetUserAvatarUrl 
                    ? `${mediaUrl}${activity.targetUserAvatarUrl}` 
                    : null;
                  
                  return (
                    <div key={index} className="d-flex align-items-center mb-3 activity-item p-2 rounded-3"
                      style={{ 
                        background: 'rgba(var(--bs-light-rgb), 0.5)',
                        transition: 'all 0.3s ease'
                      }}>
                    <div className="flex-shrink-0">
                        <div 
                          className="avatar-xs d-flex align-items-center justify-content-center bg-light rounded-circle overflow-hidden"
                          onClick={() => handleUserClick(activity.user)}
                          style={{ cursor: 'pointer' }}
                        >
                          {userAvatarUrl ? (
                            <img 
                              src={userAvatarUrl} 
                              alt={activity.userName || 'User'} 
                              className="w-100 h-100 object-fit-cover"
                              onError={(e) => {
                                e.target.onerror = null;
                                e.target.style.display = 'none';
                                if (e.target.nextSibling) {
                                  e.target.nextSibling.style.display = 'flex';
                                }
                              }}
                            />
                          ) : (
                            <div 
                              className="w-100 h-100 d-flex align-items-center justify-content-center bg-primary-subtle text-primary"
                              style={{ fontSize: '14px' }}
                            >
                              {activity.userName 
                                ? activity.userName.charAt(0).toUpperCase() 
                                : (typeof activity.user === 'string' && activity.user 
                                    ? activity.user.charAt(0).toUpperCase() 
                                    : (activity.user && activity.user.name 
                                        ? activity.user.name.charAt(0).toUpperCase() 
                                        : 'U'))}
                        </div>
                          )}
                      </div>
                    </div>
                    <div className="flex-grow-1 ms-3">
                        <h6 className="mb-1">
                          {activity.type === 'video_call' && (
                            <>
                              {activity.status === 'MISSED' && 'Missed video call'}
                              {activity.status === 'ACCEPTED' && 'Video call accepted'}
                              {activity.status === 'JOIN' && 'Joined video call'}
                              {activity.status === 'REQUESTED' && 'Video call requested'}
                              {activity.status === 'CANCELLED' && 'Video call cancelled'}
                              {activity.status === 'ENDED' && 'Video call ended'}
                              {activity.status === 'DECLINED' && 'Video call declined'}
                              {activity.status === 'STARTED' && 'Video call started'}
                            </>
                          )}
                          {activity.type === 'virtual_gift' && (
                            <span>
                              <span className="fw-medium">{activity.userName || (activity.user && activity.user.name) || activity.user || 'Unknown'}</span> sent 
                              <span className="fw-medium text-primary"> {activity.tokens || activity.amount || 0} tokens </span> 
                              to <span className="fw-medium">{activity.targetUserName || (activity.target_user && activity.target_user.name) || activity.target_user || 'Unknown'}</span>
                            </span>
                          )}
                          {activity.type === 'token_transaction' && (
                            <>
                              {activity.transaction_type && (
                                <span>
                                  <span className="fw-medium">{activity.transaction_type}</span>
                                  {activity.tokens && (
                                    <span className={activity.transaction_category === 'CREDIT' ? 'text-success fw-medium' : 'text-danger fw-medium'}>
                                      {' '}{activity.tokens} tokens
                                    </span>
                                  )}
                                </span>
                              )}
                              {!activity.transaction_type && (
                                <span>
                                  Token transaction: 
                                  <span className={activity.transaction_category === 'CREDIT' ? 'text-success fw-medium' : 'text-danger fw-medium'}>
                                    {' '}{activity.tokens || 0} tokens
                                  </span>
                                </span>
                              )}
                            </>
                          )}
                      </h6>
                        <div className="text-muted">
                          <span 
                            className="fw-medium"
                            onClick={() => handleUserClick(activity.user)}
                            style={{ cursor: 'pointer' }}
                          >
                            {activity.userName || (activity.user && activity.user.name) || activity.user || 'Unknown'}
                          </span>
                          {activity.type === 'video_call' && (
                            <>
                              <span className="mx-1">→</span>
                              <span 
                                className="fw-medium"
                                onClick={() => handleUserClick(activity.target_user)}
                                style={{ cursor: 'pointer' }}
                              >
                                {activity.targetUserName || (activity.target_user && activity.target_user.name) || activity.target_user || 'Unknown'}
                              </span>
                              {targetUserAvatarUrl && (
                                <img 
                                  src={targetUserAvatarUrl} 
                                  alt={activity.targetUserName || 'Target User'} 
                                  className="rounded-circle ms-1"
                                  style={{ width: '16px', height: '16px', objectFit: 'cover', cursor: 'pointer' }}
                                  onClick={() => handleUserClick(activity.target_user)}
                                />
                              )}
                            </>
                          )}
                          {activity.type === 'virtual_gift' && activity.target_user && (
                            <>
                              <span className="mx-1">→</span>
                              <span 
                                className="fw-medium"
                                onClick={() => handleUserClick(activity.target_user)}
                                style={{ cursor: 'pointer' }}
                              >
                                {activity.targetUserName || (activity.target_user && activity.target_user.name) || activity.target_user || 'Unknown'}
                              </span>
                            </>
                          )}
                    </div>
                        <div className="text-muted smaller">
                          {activity.icon && (
                            <span className="me-1">
                              {typeof activity.icon === 'string' && activity.icon.startsWith('ri-') 
                                ? <i className={activity.icon}></i> 
                                : activity.icon}
                            </span>
                          )}
                          {!activity.icon && <i className="ri-time-line me-1"></i>}
                          {new Date(activity.time || activity.timestamp * 1000).toLocaleString()}
                          {activity.location && activity.location !== 'N/A' && (
                            <span className="ms-2">
                              <i className="ri-map-pin-line me-1"></i>
                              {activity.location}
                            </span>
                          )}
                          {activity.color && (
                            <span 
                              className="ms-2 badge" 
                              style={{ 
                                backgroundColor: activity.color,
                                color: isLightColor(activity.color) ? '#000' : '#fff'
                              }}
                            >
                              {activity.type.replace('_', ' ')}
                            </span>
                          )}
                  </div>
                        </div>
                      </div>
                  );
                })
              )}
                    </div>
              </SimpleBar>
        </CardBody>
      </Card>

      {/* Recent Subscriptions */}
      <Card className="mb-3" style={{ height: "670px", overflow: "hidden" }}>
        <CardHeader>
          <h5 className="card-title mb-0">Recent Subscriptions</h5>
        </CardHeader>
        <CardBody className="p-0">
          <SimpleBar style={{ height: "640px" }}>
              <div className="p-3">
              {!dashboardData.subscriptions?.length || isSampleData(dashboardData.subscriptions, 'subscriptions') ? (
                <LoadingSpinner message="Loading subscriptions..." />
              ) : (
                dashboardData.subscriptions.map((subscription, index) => {
                  // Debug first item more extensively
                  if (index === 0) {
                    console.log('First subscription data:', subscription);
                    console.log('First subscription structure:', Object.keys(subscription));
                    
                    // Check if there's a subscriber property
                    if (subscription.subscriber) {
                      console.log('Subscriber property found:', subscription.subscriber);
                      console.log('Subscriber structure:', Object.keys(subscription.subscriber));
                    }
                  }
                  
                  // Get the media URL from environment variables
                  const mediaUrl = process.env.REACT_APP_MEDIA_URL || '';
                  
                  // Determine user avatar URL
                  let userAvatarUrl = null;
                  
                  // First check if profile_pic is an array (direct from API format)
                  if (subscription.profile_pic && Array.isArray(subscription.profile_pic)) {
                    // Find the first photo type item
                    const profileUrl = getProfilePictureUrl(subscription.profile_pic);
                    if (profileUrl) {
                      userAvatarUrl = processProfileUrl(profileUrl);
                      if (index === 0) console.log('Using profile_pic array URL:', userAvatarUrl);
                    }
                  } 
                  // Otherwise check other possible fields
                  else {
                    const rawUrl = subscription.userAvatarUrl || 
                                (subscription.subscriber?.profile_pic) || 
                                subscription.avatar || 
                                subscription.image || 
                                subscription.picture || 
                                subscription.photo;
                    
                    if (rawUrl) {
                      // Process the URL to ensure it's properly formed
                      userAvatarUrl = processProfileUrl(rawUrl);
                      if (index === 0) console.log('Using direct avatar URL:', userAvatarUrl);
                    } 
                    // Try profile_data if no direct URL found
                    else if (subscription.profile_data) {
                      const profileUrl = getProfilePictureUrl(subscription.profile_data);
                      if (profileUrl) {
                        userAvatarUrl = processProfileUrl(profileUrl);
                        if (index === 0) console.log('Using profile_data URL:', userAvatarUrl);
                      }
                    }
                    // Final fallback - try to build a URL using user ID
                    else {
                      const userId = subscription.user_id || 
                                   (subscription.subscriber && subscription.subscriber.id) || 
                                   (typeof subscription.user === 'object' && subscription.user.id);
                      
                      if (userId) {
                        const mediaBaseUrl = process.env.REACT_APP_MEDIA_URL || process.env.REACT_APP_MEDIA_BASE_URL || '';
                        if (mediaBaseUrl) {
                          userAvatarUrl = processProfileUrl(`${mediaBaseUrl}/users/${userId}/profile/avatar`);
                          if (index === 0) console.log('Using constructed URL from user ID:', userAvatarUrl);
                        }
                      }
                    }
                  }
                  
                  if (index === 0) {
                    console.log('Final userAvatarUrl:', userAvatarUrl);
                  }
                  
                  // Get user name
                  const userName = subscription.userName || subscription.user || 'Unknown User';
                  
                  // Get plan details
                  const planName = subscription.planName || subscription.plan || 'Unknown Plan';
                  const planColor = subscription.planColor || subscription.color || '#4b49ac';
                  const planIcon = subscription.iconEmoji || subscription.icon || '';
                  
                  // Get country and flag
                  const country = subscription.countryName || subscription.country || 'Unknown';
                  const flagEmoji = subscription.flagEmoji || subscription.flag || '🌐';
                  
                  // Get duration
                  const duration = parseInt(subscription.planDuration || subscription.duration || 1, 10);
                  
                  return (
                    <div key={index} className={`d-flex align-items-center mb-3 subscription-item subscription-item-${index} p-2 rounded-3`}
                      style={{ 
                        background: 'rgba(var(--bs-light-rgb), 0.5)',
                        transition: 'all 0.3s ease',
                        border: '1px solid rgba(var(--bs-light-rgb), 0.8)',
                        boxShadow: '0 2px 4px rgba(0,0,0,0.03)'
                      }}>
                    <div className="flex-shrink-0">
                        <div 
                          className="avatar-xs d-flex align-items-center justify-content-center bg-light rounded-circle overflow-hidden"
                          onClick={() => handleUserClick(subscription)}
                          style={{ 
                            cursor: 'pointer', 
                            width: '40px', 
                            height: '40px',
                            position: 'relative',
                            boxShadow: '0 2px 6px rgba(0,0,0,0.05)',
                            border: '1px solid rgba(0,0,0,0.05)'
                          }}
                        >
                          {userAvatarUrl ? (
                            index === 0 ? (
                              // Special handling for first subscription
                              <div 
                                ref={firstSubscriptionImageRef}
                                className="w-100 h-100 avatar-image-container"
                                style={{
                                  position: 'relative',
                                  overflow: 'hidden',
                                  borderRadius: '50%',  // Ensure circular shape
                                  backgroundSize: 'cover',
                                  backgroundPosition: 'center',
                                  backgroundRepeat: 'no-repeat'
                                }}
                              >
                                {/* Fallback for first item that's initially visible until image loads */}
                                <div 
                                  className="fallback-initial w-100 h-100 d-flex align-items-center justify-content-center bg-primary-subtle text-primary"
                                  style={{ 
                                    fontSize: '14px',
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    zIndex: 0,
                                    opacity: '1',
                                    transition: 'opacity 0.3s ease'
                                  }}
                                >
                                  {userName ? userName.charAt(0).toUpperCase() : 'U'}
                    </div>
                  </div>
                            ) : (
                              // Regular handling for other subscriptions
                              <div 
                                className="w-100 h-100 avatar-image-container"
                                style={{
                                  position: 'relative',
                                  overflow: 'hidden'
                                }}
                              >
                                {/* Image element for all items with proper error handling */}
                                <img 
                                  src={addCacheBuster(userAvatarUrl)} 
                                  alt={`${userName || "User"}'s avatar`}
                                  className="w-100 h-100"
                                  style={{ objectFit: 'cover' }}
                                  crossOrigin="anonymous"
                                  referrerPolicy="no-referrer"
                                  loading={index < 3 ? "eager" : "lazy"}
                                  onLoad={(e) => {
                                    console.log(`Subscription image ${index} loaded:`, e.target.src);
                                    // Apply success styling
                                    const container = e.target.closest('.avatar-image-container');
                                    if (container) {
                                      container.style.boxShadow = '0 0 4px rgba(0,128,0,0.3)';
                                    }
                                  }}
                                  onError={(e) => {
                                    console.error(`Failed to load subscription image ${index}:`, userAvatarUrl);
                                    
                                    // Get the parent container
                                    const container = e.target.closest('.avatar-image-container');
                                    if (container) {
                                      // Hide the image
                                      e.target.style.display = 'none';
                                      
                                      // Create fallback element if it doesn't exist yet
                                      let fallback = container.querySelector('.fallback-initial');
                                      if (!fallback) {
                                        fallback = document.createElement('div');
                                        fallback.className = 'fallback-initial w-100 h-100 d-flex align-items-center justify-content-center bg-primary-subtle text-primary';
                                        fallback.style.fontSize = '14px';
                                        container.appendChild(fallback);
                                      }
                                      
                                      // Set the user's initial as fallback content
                                      fallback.textContent = userName ? userName.charAt(0).toUpperCase() : 'U';
                                    }
                                  }}
                      />
                    </div>
                            )
                          ) : (
                            <div 
                              className="w-100 h-100 avatar-image-container d-flex align-items-center justify-content-center bg-primary-subtle text-primary"
                              style={{ 
                                fontSize: '14px',
                                position: 'relative',
                                overflow: 'hidden'
                              }}
                            >
                              {userName ? userName.charAt(0).toUpperCase() : 'U'}
                    </div>
                          )}
                  </div>
                </div>
                      <div className="flex-grow-1 ms-3">
                        <div className="d-flex align-items-center mb-1">
                          <h6 className="mb-0">
                            <button 
                              type="button"
                              onClick={() => handleUserClick(subscription)}
                              className="btn btn-link p-0 text-decoration-none cursor-pointer"
                              style={{ 
                                background: 'none',
                                border: 'none',
                                fontSize: '0.875rem',
                                fontWeight: '500',
                                color: 'var(--vz-gray-700)'
                              }}
                            >
                              {userName}
                            </button>
                </h6>
                          {flagEmoji && country && country !== 'Unknown' && (
                            <span className="ms-2">
                              {getCountryCode(country) 
                                ? <span className={`fi fi-${getCountryCode(country)}`} style={{ width: '20px', height: '15px', display: 'inline-block' }}></span>
                                : flagEmoji}
                            </span>
                          )}
                          
                          {/* Plan Badge */}
                          <span 
                            className="ms-2 badge" 
                            style={{ 
                              backgroundColor: planColor, 
                              color: '#ffffff',
                              padding: '0.25em 0.6em',
                              fontSize: '0.75em',
                              fontWeight: 'bold',
                              borderRadius: '4px',
                              border: `1px solid ${planColor}`
                            }}
                          >
                            {planIcon && <span className="me-1">{planIcon}</span>}
                            {planName}
                          </span>
                </div>
                        
                        <div className="d-flex justify-content-between align-items-center mt-1">
                          <div className="text-muted smaller">
                            <i className="ri-time-line me-1"></i>
                            {new Date(subscription.time).toLocaleString()}
              </div>
                          <div className="text-muted smaller">
                            <i className="ri-calendar-line me-1"></i>
                            {duration} {duration === 1 ? 'month' : 'months'}
                            
                            {subscription.amount && (
                              <span className="ms-2">
                                <i className="ri-money-dollar-circle-line me-1"></i>
                                ${subscription.amount}
                              </span>
                            )}
                      </div>
                    </div>
                    </div>
                  </div>
                  );
                })
              )}
                </div>
          </SimpleBar>
        </CardBody>
      </Card>

      {/* User Details Modal */}
      <UserDetailsModal
        isOpen={userDetailsModal}
        toggle={toggleUserModal}
        user={selectedUser}
        loading={loadingUser}
        getImageUrl={(url) => {
          if (!url) return '/images/default-avatar.png';
          return processProfileUrl(url);
        }}
      />

      {/* Recent Matches */}
      <Card className="mb-3" style={{ height: "730px", overflow: "hidden" }}>
        <CardHeader>
          <h5 className="card-title mb-0">Recent Matches</h5>
        </CardHeader>
        <CardBody className="p-0">
          <SimpleBar style={{ height: "710px" }}>
            <div className="p-3">
              {!dashboardData.matches?.length || isSampleData(dashboardData.matches, 'matches') ? (
                <LoadingSpinner message="Loading matches..." />
              ) : (
                dashboardData.matches.map((match, index) => {
                  // Get the media URL from environment variables
                  const mediaUrl = process.env.REACT_APP_MEDIA_URL || '';
                  
                  // Determine first user avatar URL
                  const firstUserAvatarUrl = match.first_user && match.first_user.avatarUrl 
                    ? processProfileUrl(match.first_user.avatarUrl)
                    : null;
                  
                  // Determine second user avatar URL
                  const secondUserAvatarUrl = match.second_user && match.second_user.avatarUrl 
                    ? processProfileUrl(match.second_user.avatarUrl)
                    : null;
                  
                  return (
                    <div key={index} className="match-item mb-3 p-2 rounded-3" 
                      style={{ 
                        background: 'rgba(var(--bs-light-rgb), 0.5)',
                        transition: 'all 0.3s ease',
                        border: `1px solid ${match.color || '#4CAF50'}20`,
                        boxShadow: `0 2px 8px ${match.color || '#4CAF50'}10`,
                        position: 'relative',
                        overflow: 'hidden'
                      }}>
                      <div 
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          width: '4px',
                          height: '100%',
                          background: match.color || '#4CAF50'
                        }}
                          ></div>
                      <div className="match-users">
                        <div className="d-flex align-items-center justify-content-between">
                          {/* First User - Left Side */}
                          <div className="d-flex align-items-center" style={{ flex: 1 }}>
                            <div 
                              className="avatar-sm flex-shrink-0 me-2"
                              onClick={() => handleUserClick(match.originalUser1 || match.first_user)}
                              style={{ cursor: 'pointer' }}
                            >
                              {firstUserAvatarUrl ? (
                                <img 
                                  src={addCacheBuster(firstUserAvatarUrl)} 
                                  alt={match.first_user.name || 'User'} 
                                  className="rounded-circle w-100 h-100 object-fit-cover"
                                  crossOrigin="anonymous"
                                  referrerPolicy="no-referrer"
                                  loading={index < 3 ? "eager" : "lazy"}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.style.display = 'none';
                                    
                                    // Create fallback with initial if it doesn't exist
                                    const parent = e.target.parentNode;
                                    if (!parent.querySelector('.avatar-fallback')) {
                                      const fallback = document.createElement('div');
                                      fallback.className = 'avatar-fallback w-100 h-100 d-flex align-items-center justify-content-center bg-primary-subtle text-primary rounded-circle';
                                      fallback.style.fontSize = '14px';
                                      fallback.innerText = match.first_user.name ? match.first_user.name.charAt(0).toUpperCase() : 'U';
                                      parent.appendChild(fallback);
                                    }
                                  }}
                                />
                              ) : (
                                <div 
                                  className="rounded-circle w-100 h-100 d-flex align-items-center justify-content-center bg-primary-subtle text-primary"
                                  style={{ width: '40px', height: '40px' }}
                                >
                                  {match.first_user && typeof match.first_user.name === 'string' ? match.first_user.name.charAt(0).toUpperCase() : 'U'}
                        </div>
                              )}
                      </div>
                            <div>
                              <h6 className="mb-0 fs-sm">
                                <button 
                                  type="button"
                                  onClick={() => handleUserClick(match.originalUser1 || match.first_user)}
                                  className="btn btn-link p-0 text-decoration-none cursor-pointer"
                                  style={{ 
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '0.875rem',
                                    fontWeight: '500',
                                    color: 'var(--vz-gray-700)'
                                  }}
                                >
                                  {match.first_user.name}
                                </button>
                              </h6>
                    </div>
                      </div>
                            
                          {/* Match Icon - Center */}
                          <div className="match-icon mx-2 d-flex flex-column align-items-center">
                            <div 
                              className="rounded-circle d-flex align-items-center justify-content-center match-icon-pulse" 
                              style={{ 
                                width: '36px', 
                                height: '36px', 
                                backgroundColor: match.color || '#4CAF50',
                                color: '#fff',
                                '--pulse-color': hexToRgb(match.color || '#4CAF50')
                              }}
                            >
                              <i className={`${match.icon || 'ri-heart-line'} fs-5`}></i>
                        </div>
                            {match.matchType && (
                              <span 
                                className="badge mt-1" 
                                style={{ 
                                  backgroundColor: match.color || '#4CAF50',
                                  color: '#fff',
                                  padding: '0.15em 0.4em',
                                  fontSize: '0.65em',
                                  fontWeight: 'bold',
                                  borderRadius: '4px',
                                  whiteSpace: 'nowrap'
                                }}
                              >
                                {match.matchType}
                              </span>
                            )}
                      </div>
                            
                          {/* Second User - Right Side */}
                          <div className="d-flex align-items-center justify-content-end" style={{ flex: 1 }}>
                            <div className="text-end">
                              <h6 className="mb-0 fs-sm">
                                <button 
                                  type="button"
                                  onClick={() => handleUserClick(match.originalUser2 || match.second_user)}
                                  className="btn btn-link p-0 text-decoration-none cursor-pointer"
                                  style={{ 
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '0.875rem',
                                    fontWeight: '500',
                                    color: 'var(--vz-gray-700)'
                                  }}
                                >
                                  {match.second_user.name}
                                </button>
                              </h6>
                      </div>
                            <div 
                              className="avatar-sm flex-shrink-0 ms-2"
                              onClick={() => handleUserClick(match.originalUser2 || match.second_user)}
                              style={{ cursor: 'pointer' }}
                            >
                              {secondUserAvatarUrl ? (
                                <img 
                                  src={addCacheBuster(secondUserAvatarUrl)} 
                                  alt={match.second_user.name || 'User'} 
                                  className="rounded-circle w-100 h-100 object-fit-cover"
                                  crossOrigin="anonymous"
                                  referrerPolicy="no-referrer"
                                  loading={index < 3 ? "eager" : "lazy"}
                                  onError={(e) => {
                                    e.target.onerror = null;
                                    e.target.style.display = 'none';
                                    
                                    // Create fallback with initial if it doesn't exist
                                    const parent = e.target.parentNode;
                                    if (!parent.querySelector('.avatar-fallback')) {
                                      const fallback = document.createElement('div');
                                      fallback.className = 'avatar-fallback w-100 h-100 d-flex align-items-center justify-content-center bg-primary-subtle text-primary rounded-circle';
                                      fallback.style.fontSize = '14px';
                                      fallback.innerText = match.second_user.name ? match.second_user.name.charAt(0).toUpperCase() : 'U';
                                      parent.appendChild(fallback);
                                    }
                                  }}
                                />
                              ) : (
                                <div 
                                  className="rounded-circle w-100 h-100 d-flex align-items-center justify-content-center bg-primary-subtle text-primary"
                                  style={{ width: '40px', height: '40px' }}
                                >
                                  {match.second_user && typeof match.second_user.name === 'string' ? match.second_user.name.charAt(0).toUpperCase() : 'U'}
                        </div>
                              )}
                      </div>
                    </div>
                      </div>
                    </div>
                      <div className="match-details mt-2">
                        <div className="d-flex flex-column align-items-center">
                          {match.location && match.location !== 'N/A' && (
                            <div className="text-muted smaller mb-1 text-center" style={{ maxWidth: '100%' }}>
                              <i className="ri-map-pin-line me-1"></i>
                              {match.location}
                            </div>
                          )}
                          
                          <div className="text-muted smaller text-center">
                            <i className="ri-time-line me-1"></i>
                            {new Date(match.time).toLocaleString()}
                      </div>
                    </div>
                        </div>
                      </div>
                  );
                })
              )}
              <div className="text-center mt-3">
                <Link to="/match-logs" className="btn btn-soft-primary btn-sm">
                  View all matches <i className="ri-arrow-right-line align-middle"></i>
                </Link>
                    </div>
                      </div>
          </SimpleBar>
        </CardBody>
      </Card>

      {/* Top Locations */}
      <Card style={{ height: "640px", overflow: "hidden" }}>
        <CardHeader className="align-items-center d-flex">
          <h5 className="card-title mb-0 flex-grow-1">Top Locations</h5>
          <div className="flex-shrink-0">
            <Link to="/locations" className="btn btn-soft-primary btn-sm">
              View All <i className="ri-arrow-right-line align-middle"></i>
            </Link>
                      </div>
        </CardHeader>
        <CardBody className="p-0">
          <SimpleBar style={{ height: "640px" }}>
              <div className="p-3">
              {!dashboardData.topLocations?.length || isSampleData(dashboardData.topLocations, 'topLocations') ? (
                <LoadingSpinner message="Loading locations..." />
              ) : (
                dashboardData.topLocations.map((location, index) => (
                  <div key={index} className="d-flex align-items-center mb-3 p-2 rounded-3 location-item" 
                    style={{ 
                      background: 'rgba(var(--bs-light-rgb), 0.5)',
                      transition: 'all 0.3s ease',
                      borderBottom: index !== dashboardData.topLocations.length - 1 ? '1px solid var(--vz-border-color)' : 'none'
                    }}>
                      <div className="flex-shrink-0">
                        <div className="d-flex align-items-center justify-content-center bg-light rounded-circle" 
                             style={{ width: '45px', height: '45px', overflow: 'hidden' }}>
                          {location.country && countryToCode[location.country.toLowerCase()] ? (
                            <span 
                              className={`fi fi-${countryToCode[location.country.toLowerCase()]}`}
                              style={{ 
                                width: '32px', 
                                height: '24px',
                                borderRadius: '2px',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                              }}
                            ></span>
                          ) : (
                            <i className="ri-global-line fs-3 text-primary"></i>
                          )}
                        </div>
                      </div>
                        <div className="flex-grow-1 ms-3">
                          <div className="d-flex justify-content-between align-items-start mb-1">
                            <h6 className="mb-0 fw-semibold">
                              {location.city}
                              <span className="text-muted ms-1 fw-normal">
                                • {location.country}
                              </span>
                            </h6>
                            <span className={`badge bg-${location.trend === 'up' ? 'success' : 'danger'}-subtle text-${location.trend === 'up' ? 'success' : 'danger'}`}>
                              <i className={`ri-arrow-${location.trend === 'up' ? 'up' : 'down'}-line align-middle me-1`}></i>
                              {location.trend.toUpperCase()}
                            </span>
                    </div>
                          <div className="text-muted small">
                            <i className="ri-user-3-line align-middle me-1"></i>
                            {location.count.toLocaleString()} active users
                      </div>
                    </div>
                </div>
                  ))
              )}
              </div>
          </SimpleBar>
                </CardBody>
              </Card>

      <style jsx="true">{`
          .heart-beat {
            animation: heartBeat 1.5s ease infinite;
          }

          @keyframes heartBeat {
            0% { transform: scale(1); }
            14% { transform: scale(1.3); }
            28% { transform: scale(1); }
            42% { transform: scale(1.3); }
            70% { transform: scale(1); }
          }

          .match-item:hover, .subscription-item:hover, .location-item:hover {
            background: rgba(var(--bs-light-rgb), 0.5);
            transform: translateX(5px);
          }

          .smaller {
            font-size: 0.75rem;
          }

          .fi {
            border: 1px solid var(--vz-border-color);
          }

          .spin {
            animation: spin 1s linear infinite;
          }

          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }

          .cursor-pointer {
            cursor: pointer;
          }
          
          .cursor-pointer:hover {
            color: #405189 !important;
            text-decoration: underline;
          }

          .simplebar-content-wrapper {
            height: 95% !important;
          }
          
          @keyframes pulse {
            0% {
              box-shadow: 0 0 0 0 rgba(var(--pulse-color, 76, 175, 80), 0.7);
            }
            70% {
              box-shadow: 0 0 0 10px rgba(var(--pulse-color, 76, 175, 80), 0);
            }
            100% {
              box-shadow: 0 0 0 0 rgba(var(--pulse-color, 76, 175, 80), 0);
            }
          }
          
          .match-icon-pulse {
            --pulse-color: 76, 175, 80;
            animation: pulse 2s infinite;
          }
        `}
      </style>
        </div>
  );
};

export default RecentActivity;

